import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']
  static classes = ['active', 'inactive']
  static values = { activeId: { type: String, default: 'step-1' } }

  connect() {
    // Check URL params for direct link
    const params = new URLSearchParams(window.location.search)
    const urlTab = params.get('tab')
    const initialId = urlTab || this.activeIdValue

    this.showTab(initialId)
  }

  activeIdValueChanged(id) {
    if (id) this.showTab(id)
  }

  switch(event) {
    event.preventDefault()
    const targetId = event.currentTarget.dataset.target

    // 1. Get the currently visible panel (the one the user is looking at)
    const currentPanel = this.panelTargets.find(panel => !panel.classList.contains('hidden'))

    // 2. If we found a panel and the user is trying to leave it
    if (currentPanel && currentPanel.id !== targetId) {
      if (this.hasErrors(currentPanel)) {
        console.log("Validation blocked switch from:", currentPanel.id)
        return // EXIT HERE - do not call showTab
      }
    }

    this.showTab(targetId)
  }

  // Helper to detect Rails validation errors or browser-level invalid inputs
  hasErrors(panel) {
    // 1. Check for visible Rails error messages (server-side red text)
    const hasVisibleErrors = panel.querySelectorAll('.text-red-500, .error-message').length > 0
    if (hasVisibleErrors) return true

    // 2. Custom Client-side Check: Surgery dependency
    const surgeries = panel.querySelector('[name*="[surgeries]"]')
    const surgeriesDate = panel.querySelector('[name*="[surgeries_date]"]')

    if (surgeries && surgeriesDate) {
      if (surgeries.value.trim() !== '' && surgeriesDate.value === '') {
        // Force visual error and block switch
        surgeriesDate.classList.add('border-red-500', 'ring-1', 'ring-red-500')
        surgeriesDate.focus()
        alert("Surgery Date is required when surgery details are provided.")
        return true
      }
    }

    // 3. Force Browser Validation: Check every input in the panel
    const inputs = panel.querySelectorAll('input, select, textarea')
    let isInvalid = false

    inputs.forEach(input => {
      // checkValidity() returns false if the field violates HTML5 rules (required, minlength, etc.)
      if (!input.checkValidity()) {
        input.reportValidity() // This shows the browser's native error bubble
        isInvalid = true
      }
    })

    return isInvalid
  }

  showTab(targetId) {
    // Toggle Panels
    this.panelTargets.forEach(panel => {
      if (panel.id === targetId) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })

    // Toggle Tab Button Styles
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.target === targetId

      if (isActive) {
        tab.classList.add(...this.activeClasses)
        tab.classList.remove(...this.inactiveClasses)
      } else {
        tab.classList.remove(...this.activeClasses)
        tab.classList.add(...this.inactiveClasses)
      }
    })
  }
}
